import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoticesPageComponent } from './notices-page/notices-page.component';
import { PartialModule } from '../partial/partial.module';

@NgModule({
  declarations: [
    NoticesPageComponent
  ],
  imports: [
    CommonModule,
    PartialModule
  ],
  exports: [
    NoticesPageComponent
  ]
})
export class NoticesModule { }
